<ng-container *ngIf="sucesso; else formObraDescartada">
  <app-sucesso
    [mensagem]="'Obra descartada com sucesso!'"
    [botaoTexto]="'Continuar'"
    (continuar)="continuar()"
  ></app-sucesso>
</ng-container>
<ng-template #formObraDescartada>
  <div class="obra-descartada-container">
    <div class="form-content">
      <label for="taskDescription">Descreva o Relato sobre o Descarte</label>
      <textarea
        id="taskDescription"
        class="form-control"
        [(ngModel)]="taskDescription"
        placeholder="Descreva o relato sobre o descarte..."
      ></textarea>

      <select
  id="responsavel"
  class="form-control custom-select"
  [(ngModel)]="responsavelSelecionado"
  (ngModelChange)="campoObrigatorioErro = false"
  [ngClass]="{
    'is-invalid': campoObrigatorioErro && !responsavelSelecionado
  }"
>

        <option value="">Selecione o responsável</option>
        <option *ngFor="let option of responsavel" [ngValue]="option.id">
          {{ option.name }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !responsavelSelecionado"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>
    </div>
 

    <div class="footer-actions">
      <button class="btn btn-secondary" type="button" (click)="clear()">
        Limpar Dados
      </button>
      <button class="btn btn-primary" type="button" (click)="atualizarObraDescartada()">
        Obra Descartada
      </button>
    </div>
  </div>
</ng-template>
